export function isImageDownloadable(imageUrl: string): Promise<boolean> {
  return new Promise((resolve) => {
    const img = new Image();

    // If the image loads successfully
    img.onload = () => resolve(true);

    // If there's an error loading the image (e.g., 404, server error)
    img.onerror = () => resolve(false);

    // Set the source of the image to trigger loading
    img.src = imageUrl;
  });
}
